import { render, staticRenderFns } from "./Metrica.vue?vue&type=template&id=06dc36bc&"
import script from "./Metrica.vue?vue&type=script&lang=js&"
export * from "./Metrica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports